export type MergeSyncHealthStatusType = ValueOf<typeof MERGE_SYNC_HEALTH_STATUS_TYPE>;

// This is duplicated in the server
export const MERGE_SYNC_HEALTH_STATUS_TYPE = {
  GOOD: 'GOOD',
  DELAYED: 'DELAYED',
  REAUTHENTICATION_NEEDED: 'REAUTHENTICATION_NEEDED',
  PAUSED: 'PAUSED',
  SYNCING: 'SYNCING',
} as const;

export interface MergeSyncHealth {
  status: MergeSyncHealthStatusType;
  description?: string | null;
}
